export const tokenInfo = {
  TENDER: {
    label: 'TheCurrency',
    img: '/images/tokens/TENDER.png',
  },
  DAI: {
    label: 'DAI Stablecoin',
    img: '/images/tokens/DAI.png',
  },
  ETH: {
    label: 'Ether',
    img: '/images/tokens/ETH.png',
  },
  PAT: {
    label: 'Portion Art Token',
    img: '/images/tokens/PAT.png',
  },
  PRT: {
    label: 'Portion Token',
    img: '/images/tokens/PRT.png',
  },
  WETH: {
    label: 'Wrapped Ether',
    img: '/images/tokens/WETH.png',
  },
  SLP: {
    label: 'SushiSwap LP',
  },
  WPALM: {
    label: 'Wrapped PALM',
  },
  // Currently not on palm but include anyway
  AST: {
    label: 'AirSwap',
    img: '/images/tokens/AST.png',
  },
  ZRX: {
    label: '0x',
    img: '/images/tokens/ZRX.png',
  },
  BAT: {
    label: 'Basic Attention Token',
    img: '/images/tokens/BAT.png',
  },
  BNT: {
    label: 'Bancor',
    img: '/images/tokens/BNT.png',
  },
  CVL: {
    label: 'Civil',
    img: '/images/tokens/CVL.png',
  },
  LINK: {
    label: 'Chainlink',
    img: '/images/tokens/LINK.png',
  },
  OMG: {
    label: 'OMG',
    img: '/images/tokens/OMG.png',
  },
  SAI: {
    label: 'SAI Stablecoin',
    img: '/images/tokens/SAI.png',
  },
  SNX: {
    label: 'Synthetic',
    img: '/images/tokens/SNX.png',
  },
  WBTC: {
    label: 'Wrapped Bitcoin',
    img: '/images/tokens/WBTC.png',
  },
  WED: {
    label: 'Wednesday Coin',
    img: '/images/tokens/WED.png',
  },
  SUSHI: {
    label: 'SushiSwap',
    img: '/images/tokens/SUSHI.png',
  },
};
